import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="file-field"
export default class extends Controller {
  static targets = ["fileField", "signedIdField"];

  simulateFileFieldClick() {
    this.fileFieldTarget.click();
  }

  markForDeletion(e) {
    const signedIdField = this.signedIdFieldTargets.find(
      (field) => field.value === e.params.signedId,
    );

    signedIdField.toggleAttribute("disabled", e.target.checked);
  }
}
